module.exports = __webpack_public_path__ + "img/likes.873116e0.svg";